/** 
 * Exports React Components that compose @chakra-ui/react and Formik components 
        into intuitive [Type]FormControl components with standardized interfaces.
   
 * @usage 
        <Formik initialValues={{ title: '' }}>
            <TextFormControl
                name="title"
                label="Title"
                placeholder="Course Title"
                validate={ value => {
                    if(value === ''){
                        return 'Course title cannot be empty.'
                    }
                }}
            />
        </Formik>

 * @param name - The name of the property for the control. Expected to be present
        in the 'initialValues' passed to the parent 'Formik' component.

 * @param label - The label to display to the user for the control.

 * @param placeholder - The placeholder to display to the user within the input.
    
 * @param validate - A callback funtion for Formik to use to validate the input.

 * Some form controls extend the common interface with type-specific paramters. 
        For example, SwitchControl adds helper text for it's On/Off states:

        <Formik initialValues={{ isVisible: false }}>
            <SwitchFormControl
                name="isVisible"
                label="Visibility"
                onHelperText="Enabled"
                offHelperText="Disabled"
            />
        </Formik>
*/
export * from './TextFormControl';
export * from './TextareaFormControl';
export * from './SwitchFormControl';
